import { render, staticRenderFns } from "./ProductTable.pug?vue&type=template&id=2560945e&scoped=true&lang=pug&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductTable.scss?vue&type=style&index=0&id=2560945e&lang=scss&scoped=true&"
import style1 from "./ProductTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560945e",
  null
  
)

export default component.exports